import { render } from "./indexDestination.vue?vue&type=template&id=4633623d"
import script from "./indexDestination.vue?vue&type=script&lang=js"
export * from "./indexDestination.vue?vue&type=script&lang=js"

import "./indexDestination.vue?vue&type=style&index=0&id=4633623d&lang=css"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__